import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import AppLayout from "@/components/layout/AppLayout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Equipment from "@/pages/Equipment";
import Inspections from "@/pages/Inspections";
import InspectionDetail from "@/pages/InspectionDetail";
import Certificates from "@/pages/Certificates";
import Reports from "@/pages/Reports";
import UsersAdmin from "@/pages/UsersAdmin";
import Schedules from "@/pages/Schedules";
import JobBoard from "@/pages/JobBoard";
import Portal from "@/pages/Portal";
import AcceptInvite from "@/pages/AcceptInvite";
import Assets from "@/pages/Assets";
import ApprovalSLA from "@/pages/ApprovalSLA";
import Learning from "@/pages/Learning";
import Documents from "@/pages/Documents";
import TrainingAdmin from "@/pages/TrainingAdmin";
import Billing from "@/pages/Billing";
import YellowCards from "@/pages/YellowCards";
import Templates from "@/pages/Templates";
import Organizations from "@/pages/Organizations";
import MyCustomers from "@/pages/MyCustomers";
import Customers from "@/pages/Customers";
import Tenants from "@/pages/Tenants";
import AuditLogs from "@/pages/AuditLogs";
import Account from "@/pages/Account";

function ProtectedRoute({ children }) {
  const { user, ready } = useAuth();
  if (!ready) return <div className="min-h-screen flex items-center justify-center text-gray-500 text-sm">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === "customer") return <Navigate to="/portal" replace />;
  return children;
}

function CustomerRoute({ children }) {
  const { user, ready } = useAuth();
  if (!ready) return <div className="min-h-screen flex items-center justify-center text-gray-500 text-sm">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== "customer") return <Navigate to="/dashboard" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/portal" element={<CustomerRoute><Portal /></CustomerRoute>} />
            <Route
              element={
                <ProtectedRoute>
                  <AppLayout />
                </ProtectedRoute>
              }
            >
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/equipment" element={<Equipment />} />
              <Route path="/inspections" element={<Inspections />} />
              <Route path="/inspections/:id" element={<InspectionDetail />} />
              <Route path="/certificates" element={<Certificates />} />
              <Route path="/reports" element={<Reports />} />
              <Route path="/admin/users" element={<UsersAdmin />} />
              <Route path="/schedules" element={<Schedules />} />
              <Route path="/assets" element={<Assets />} />
              <Route path="/approval-sla" element={<ApprovalSLA />} />
              <Route path="/learning" element={<Learning />} />
              <Route path="/documents" element={<Documents />} />
              <Route path="/training" element={<TrainingAdmin />} />
              <Route path="/billing" element={<Billing />} />
              <Route path="/yellow-cards" element={<YellowCards />} />
              <Route path="/templates" element={<Templates />} />
              <Route path="/organizations" element={<Organizations />} />
              <Route path="/my-customers" element={<MyCustomers />} />
              <Route path="/customers" element={<Customers />} />
              <Route path="/products" element={<Navigate to="/assets" replace />} />
              <Route path="/superadmin/tenants" element={<Tenants />} />
              <Route path="/audit-logs" element={<AuditLogs />} />
              <Route path="/account" element={<Account />} />
              <Route path="/board" element={<JobBoard />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="top-right" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;